/**
 * ecommate: Collection USP bar carousel (mobile)
 */
(function () {
  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function init(bar) {
    if (!bar || bar.dataset.emUspInit) return;
    bar.dataset.emUspInit = '1';
    var items = bar.querySelectorAll('.em-usp-bar__item');
    if (!items.length) return;
    var prev = bar.querySelector('.em-usp-bar__nav--prev');
    var next = bar.querySelector('.em-usp-bar__nav--next');
    var current = 0;
    var timer;
    var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    function show(index) {
      items[current].classList.remove('is-active');
      current = (index + items.length) % items.length;
      items[current].classList.add('is-active');
    }

    function stopAutoplay() {
      clearInterval(timer);
      timer = null;
    }

    function startAutoplay() {
      stopAutoplay();
      if (prefersReducedMotion()) return;
      timer = setInterval(function () {
        show(current + 1);
      }, 5000);
    }

    if (prev) prev.addEventListener('click', function () {
      show(current - 1);
      startAutoplay();
    });
    if (next) next.addEventListener('click', function () {
      show(current + 1);
      startAutoplay();
    });

    if (typeof motionQuery.addEventListener === 'function') {
      motionQuery.addEventListener('change', function () {
        startAutoplay();
      });
    } else if (typeof motionQuery.addListener === 'function') {
      motionQuery.addListener(function () {
        startAutoplay();
      });
    }

    startAutoplay();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.em-usp-bar').forEach(init);
  });
  document.addEventListener('shopify:section:load', function (event) {
    var bar = event.target.querySelector && event.target.querySelector('.em-usp-bar');
    if (bar) init(bar);
  });
})();
